/*  
 *  Archivo destinado a manejar todas las funciones responsables de comunicación con 
 *  el servidor, referentes al usuario.
 */

import uploadFile from "../firebase/uploadFile";
import fetchData from "./utils/fetchData";
import { v4 as uuidv4 } from "uuid"

const url = process.env.REACT_APP_SERVER_URL + '/user';

export const register = async (user, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + '/register', body: user }, dispatch);
    const result = data.result;
    if (result) {
        dispatch({ type: 'UPDATE_USER', payload: result });
        dispatch({ type: 'CLOSE_LOGIN' });
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: 'Usuario creado con éxito!' } });
    }

    dispatch({ type: 'END_LOADING' })
}

export const login = async (user, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + '/login', body: user }, dispatch);
    const result = data?.result;
    if (result) {
        dispatch({ type: 'UPDATE_USER', payload: result });
        dispatch({ type: 'CLOSE_LOGIN' });
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: 'Usuario logueado con éxito!' } });
    }

    dispatch({ type: 'END_LOADING' })
}

export const updateProfile = async (currentUser, updatedFields, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //SEND REQUEST WITH FETCH
    const { name, file } = updatedFields;
    let body = { name };
    let photoURL ='';
    try {
        if (file) {
            const imageName = uuidv4() + '.' + file?.name?.split('.')?.pop();
            //console.log(imageName);
            photoURL = await uploadFile(file, `profile/${currentUser?.id}/${imageName}`);
        }else {
            photoURL = currentUser.photoURL;
        }
        body = { ...body, photoURL };
        const data = await fetchData({ url: url + `/updateProfile`, method: 'PATCH', body, token: currentUser.token }, dispatch);
        const result = data?.result;
        if (result) {
            //console.log({result});
            dispatch({ type: 'UPDATE_USER', payload: { ...currentUser, ...result } });
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: data.message } });
            dispatch({ type: 'UPDATE_PROFILE', payload: { open: false, file: null, photoURL: result.photoURL } });
        } else {
            dispatch({ type: 'UPDATE_PROFILE', payload: { open: false, file: null, photoURL: '' } });
            dispatch({type: 'UPDATE_USER', payload: null});
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: "Algo salió mal con sus credenciales.Por favor intenete nuevamente en unos minutos." } });
        }

    } catch (error) {
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: error.message } });
        console.log(error);
    }

    dispatch({ type: 'END_LOADING' })
}

export const getUsers = async (comando, currentUser, dispatch) => {
    //console.log('-------------->> getUsers');
    //console.log(currentUser);

    if(!currentUser)
        return;

        dispatch({ type: 'START_LOADING' });
    
    let body = { comando };

    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/getUsers`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        dispatch({ type: 'UPDATE_USERS', payload: result });      //A users se envía el payload como {rows: valor}
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

export const updateUser = async(datos, currentUser, dispatch) => {
    //dispatch({ type: 'START_LOADING' });  //porque tiene su propio control de loading

    //console.log('-------------->> updateUser');
    //console.log('Datos: ', datos);

    let body = datos;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/updateUser`, method: 'PATCH', body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    //dispatch({ type: 'END_LOADING' })

}